
export const pricing = {
  'request.pricing': 'Demander les prix',
  'view.pricing': 'Voir les prix',
  'product.pricing': 'Prix des produits',
};
